import { format, parse, eachMinuteOfInterval, isToday } from 'date-fns';
import { useState, useEffect } from 'react';
import { uk } from 'date-fns/locale';

export const HoursInput = ({props}) => {

    const {currentDate, schedule} = props;

    const [hoursRange, setHoursRange] = useState([]);

    useEffect(() => {
        if(currentDate) {
            getCurrentWorkHours(props);
        }
    }, [currentDate])

    const getCurrentWorkHours = (values) => {
        const {currentDate, schedule} = values;

        const date = parse(currentDate, 'dd-MM-yyyy', new Date());

        const day = format(date, 'eeee', {locale: uk});
        const timeRange = schedule().find(hour => hour.hasOwnProperty(day));
        let  start = parse(timeRange[day].start, 'HH:mm', new Date());
        const end = parse(timeRange[day].end, 'HH:mm', new Date());

        if (isToday(date)) {

            start = new Date();
        }
      
        const minutes = eachMinuteOfInterval({ start, end });
      
        const hoursList = minutes.filter((minute) => {
          const formattedTime = format(minute, 'mm');
          return formattedTime === '00' || formattedTime === '30';
        });

        setHoursRange(hoursList);
    }

    const hoursOptions = hoursRange.map((hour, index) => {
        const current = format(hour, 'HH:mm');
        return (
            <option key={index} value={current}>{current}</option>
        )
    })


    return (
        <div className="col-auto">
            <label  className="form-label fs-6 fw-bold">Оберіть час</label>
            <select  defaultValue={`today`} className="form-select  fw-bold" name='ship-hour' required>
                <option value="today" disabled>Оберіть час</option>
                {hoursOptions && 
                    hoursOptions
                }
            </select>
        </div>
    )
}